/** Gallery detail header — back chevron (20×20, fill via currentColor / gray.600). */
export function ConfigurationPanelGalleryBackIcon() {
  return (
    <svg
      aria-hidden
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.50879 1.21854C8.80162 0.925821 9.27646 0.925884 9.56934 1.21854C9.86188 1.51142 9.86202 1.98628 9.56934 2.27907L2.55957 9.28778H18.5127C18.9267 9.288 19.2626 9.62378 19.2627 10.0378C19.2627 10.4518 18.9267 10.7875 18.5127 10.7878H2.55957L9.56934 17.7974L9.62109 17.8541C9.86114 18.1486 9.84375 18.5835 9.56934 18.858C9.29497 19.132 8.86087 19.1493 8.56641 18.9097L8.50879 18.858L0.219727 10.568C0.18835 10.5366 0.160394 10.5026 0.135742 10.4675C0.132269 10.4625 0.128354 10.4578 0.125 10.4528C0.115506 10.4385 0.109002 10.4226 0.100586 10.4079C0.0849364 10.3805 0.0687944 10.3533 0.0566406 10.3239C0.0499829 10.3078 0.046501 10.2906 0.0410156 10.2741C0.0161827 10.1995 0 10.1207 0 10.0378C1.99669e-05 9.95668 0.0152351 9.87947 0.0390625 9.80633C0.0445148 9.78951 0.0480151 9.77202 0.0546875 9.75555L0.0585938 9.74578C0.066117 9.72802 0.0771166 9.71204 0.0859375 9.695C0.120563 9.62794 0.163507 9.56372 0.219727 9.5075L8.50879 1.21854Z"
        fill="currentColor"
      />
    </svg>
  );
}
